import { THEME_STORAGE_KEY } from './theme';

const PREFERRED_KEYS = [THEME_STORAGE_KEY, 'lang'];

/**
 * Clear localStorage but keep UI preferences (theme, language).
 */
export function clearLocalStoragePreservingPrefs() {
    const kept = {};
    for (const key of PREFERRED_KEYS) {
        try {
            const value = localStorage.getItem(key);
            if (value != null) kept[key] = value;
        } catch {
            // ignore
        }
    }

    try {
        localStorage.clear();
    } catch {
        return;
    }

    for (const [key, value] of Object.entries(kept)) {
        try {
            localStorage.setItem(key, value);
        } catch {
            // ignore
        }
    }
}
